"use client";

import { useState } from "react";
import Text from "../ui/text";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { processTextWithEntities } from "@/utils/story";

const FaqItem = ({
  question,
  entities = [],
  answer,
  citations,
  isLastItem,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleFaq = () => setIsOpen(!isOpen);

  const processedAnswer = processTextWithEntities(answer, entities || []);

  // Normalize citations to always be an array
  const safeCitations = Array.isArray(citations)
    ? citations
    : citations && typeof citations === "object"
    ? [citations] // Convert the object to an array if it's a single citation
    : [];

  return (
    <div
      className={`w-full ${
        isLastItem ? "" : "border-b border-zinc-200 dark:border-zinc-800"
      }`}
    >
      <button
        className="w-full text-left font-medium py-4 flex justify-between gap-4"
        onClick={toggleFaq}
      >
        <Text className="text-base md:text-lg">{question}</Text>
        {isOpen ? (
          <ChevronUpIcon className="mt-1.5 text-zinc-950 dark:text-zinc-300 w-4 h-4" />
        ) : (
          <ChevronDownIcon className="mt-1.5 text-zinc-950 dark:text-zinc-300 w-4 h-4" />
        )}
      </button>
      {isOpen && (
        <div className="pb-4 px-4 space-y-4">
          <Text className="text-sm md:text-base">{processedAnswer}</Text>
          {safeCitations.length > 0 && (
            <div className="mt-2">
              {safeCitations.map((citation, index) => (
                <span key={index}>
                  <a
                    href={citation.uri}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs md:text-sm text-blue-600 dark:text-blue-400 underline"
                  >
                    {citation.name}
                  </a>
                  {index < safeCitations.length - 1 && ", "}
                </span>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FaqItem;
